import * as joint from "@clientio/rappid";
import { PreferenceStore } from "../preference-store";
import lightCSS from "../../light.css?raw";
import darkCSS from "../../dark.css?raw";
import aceCSS from "../../ace.css?raw";
import aceExportCSS from "../../ace-export.css?raw";
import aceTomorrowTheme from "ace-builds/css/theme/tomorrow.css?raw";
import aceMonokaiTheme from "ace-builds/css/theme/monokai.css?raw";

const stylesheet = [lightCSS, darkCSS, aceCSS, aceExportCSS, aceTomorrowTheme, aceMonokaiTheme].join("\n");

export class ImageExporter {
  paperScroller: joint.ui.PaperScroller;
  exportSvg(
    paper: joint.dia.Paper,
    paperScroller: joint.ui.PaperScroller,
    filename: string,
    callback?: (svg: string) => void
  ) {
    this.paperScroller = paperScroller;
    paper.hideTools();

    joint.format.toSVG(
      paper,
      callback
        ? callback
        : (svg: string) => {
            new joint.ui.Lightbox({
              image: "data:image/svg+xml," + encodeURIComponent(svg),
              downloadable: true,
              fileName: filename,
            }).open();
          },
      {
        preserveDimensions: true,
        convertImagesToDataUris: true,
        useComputedStyles: false,
        stylesheet: stylesheet,
      }
    );

    paper.showTools();
  }

  exportPng(
    paper: joint.dia.Paper,
    paperScroller: joint.ui.PaperScroller,
    filename: string,
    callback?: (dataURL: string) => void
  ) {
    this.paperScroller = paperScroller;
    paper.hideTools();

    joint.format.toPNG(
      paper,
      callback
        ? callback
        : (dataURL: string) => {
            new joint.ui.Lightbox({
              image: dataURL,
              downloadable: true,
              fileName: filename,
            }).open();
          },
      {
        padding: 10,
        backgroundColor: PreferenceStore.INSTANCE.theme.app.background,
        useComputedStyles: false,
        stylesheet: stylesheet,
      }
    );

    paper.showTools();
  }
}
